<template>
  <div>
    <PasswordCard
      v-if="isFirst"
      v-model="password"
      :error="errorMessage"
      :title="$t('setPassword')"
      @submit="handleSubmitPassword"
      @input="errorMessage = ''"
    />

    <PasswordCard
      v-else
      v-model="password2"
      :error="errorMessage"
      :title="$t('confirmPassword')"
      @submit="handleConfirmPassword"
      @input="errorMessage = ''"
    />
  </div>
</template>

<script>
import PasswordCard from '@/components/PasswordCard/index.vue'
export default {
  name: 'DoubleCheckPasswordCard',

  components: {
    PasswordCard
  },

  props: {
    value: {
      type: String,
      default: ''
    },

    oldPassword: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      password: '',
      password2: '',
      isFirst: true,
      errorMessage: ''
    }
  },

  methods: {
    // 不能连续字符（如123）连续3位或3位以上
    isSimple (str) {
      const arr = str.split('')
      for (let i = 1; i < arr.length - 1; i++) {
        const firstIndex = arr[i - 1].charCodeAt()
        const secondIndex = arr[i].charCodeAt()
        const thirdIndex = arr[i + 1].charCodeAt()
        if (
          (thirdIndex - secondIndex === 1 && secondIndex - firstIndex === 1) ||
          (secondIndex - thirdIndex === 1 && firstIndex - secondIndex === 1)
        ) {
          return true
        }
      }

      return false
    },

    // 输完密码后
    handleSubmitPassword () {
      if (this.isSimple(this.password)) {
        this.errorMessage = this.$t('passwordSimple')// 您的密码过于简单，请重新设置
        this.password = ''
        return false
      }

      if (/(\w)*(\w)\2{2}(\w)*/g.test(this.password)) {
        this.errorMessage = this.$t('passwordSame')
        this.password = ''
        return false
      }

      if (this.password === this.oldPassword) {
        this.errorMessage = this.$t('oldNewPassword') // 新旧密码相同，请重试
        this.password = ''
        return false
      }

      this.errorMessage = ''
      this.isFirst = false
    },

    // 确认密码
    handleConfirmPassword () {
      if (this.password !== this.password2) {
        this.errorMessage = this.$t('passwordAndConfirm') // 两次输入密码不一致
        return
      }

      this.errorMessage = ''
      this.$emit('input', this.password2)
      this.$emit('submit', this.password2)
    }
  }
}
</script>

<style lang="scss" scoped>
.password-block {
  /* stylelint-disable selector-pseudo-element-no-unknown, no-duplicate-selectors */
  ::v-deep .flash-block__content {
    height: 490px;

    .flash-block_header {
      padding: 48px 44px 74px 46px;
      font-size: 32px;
      text-align: center;

      p {
        text-align: left;
        display: inline-block;
      }
    }

    .flash-block_body {
      padding-bottom: 100px;
    }

    .md-codebox-box {
      background: #fff;
      border: 2px solid #e5e5e5;
      border-radius: 10px;
    }
  }
}
</style>
